import React from "react";

const classnames = {
  mercury: "text-12 leading-tight text-white uppercase",
  venus: "text-14 leading-tight text-blue underline hover:no-underline cursor-pointer",
  earth: "text-14 leading-tight",
  mars: "text-16 leading-tight bold",
  jupiter: "text-14 leading-tight text-grey-1",
  saturn: "text-14 leading-tight text-pink",
  uranus: "text-12 leading-tight text-grey-darker-1",
  neptune: "text-16 leading-tight",
};

function Text({ children, ui = "earth", ...restProps }) {
  return (
    <div className={classnames[ui]} {...restProps}>
      {children}
    </div>
  );
}

export default Text;
